import {Component, OnDestroy, OnInit} from "@angular/core";
import {GefConnectionDto} from "../../../../core/dtos/gef/gef-connection-dto";
import {GestionGefService} from "../../../../core/services/gef/gestion-gef.service";
import {UtilsService} from "../../../../core/utils/utils.service";
import {Subscription} from "rxjs";
import {ButtonThemeEnum} from "../../../../shared/ui/button/button-theme-enum";
import {GEF_FLUX_DISPONIBLE, MSG_KEY, MSG_SEVERITY} from "../../../../core/constants";
import {ToastService} from "../../../../core/services/technique/toast.service";
import {confirm} from "devextreme/ui/dialog";

@Component({
  selector: 'yo-connections-gef-mass-edit-dialog',
  templateUrl: './connections-gef-mass-edit-dialog.component.html',
  styleUrls: ['./connections-gef-mass-edit-dialog.component.scss'],
  standalone: false
})
export class ConnectionsGefMassEditDialogComponent implements OnInit, OnDestroy {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  displayDialog = false;
  connectionList: GefConnectionDto[] = [];
  fluxList: {id: string, libelle: string}[] = [];
  selectedFluxList: string[] = [];

  subOpenDialog: Subscription;
  subSave: Subscription;

  constructor(private gestionGefSvc: GestionGefService, private utilsSvc: UtilsService, private toastSvc: ToastService) {}

  ngOnInit(): void {
    this.subOpenDialog = this.gestionGefSvc.openModificationMasseDialog$.subscribe(connectionList => {
      this.connectionList = connectionList;
      this.selectedFluxList = [];
      this.fluxList = this.buildFluxList(this.providerCode);
      this.displayDialog = true;
    });
  }

  get providerCode(): string {
    return String(this.connectionList[0]?.gefProvider?.code ?? '');
  }

  private buildFluxList(providerCode: string): {id: string, libelle: string}[] {
    return Object.entries(GEF_FLUX_DISPONIBLE)
      .filter(([key]) => key.startsWith(providerCode))
      .map(([key, value]) => ({id: key, libelle: value as string}));
  }

  private getFluxToRemove(): {id: string, libelle: string}[] {
    const allExisting = new Set<string>();
    this.connectionList.forEach(c => c.gefFluxList.forEach(f => allExisting.add(f)));
    return this.fluxList.filter(f => allExisting.has(f.id) && !this.selectedFluxList.includes(f.id));
  }

  isSaving = false;

  async save(): Promise<void> {
    if (this.isSaving) return;
    const fluxToRemove = this.getFluxToRemove();
    if (fluxToRemove.length) {
      const labels = fluxToRemove.map(f => f.libelle).join('<br>');
      const msg = `Les flux suivants seront désabonnés sur toutes les configurations sélectionnées :<br><br><strong>${labels}</strong><br><br>L'historique GEF associé sera définitivement supprimé. Continuer ?`;
      const ok = await confirm(msg, 'Confirmation de désabonnement');
      if (!ok) return;
    }
    this.isSaving = true;
    const idList = this.connectionList.map(c => c.id);
    this.utilsSvc.unsubscribe(this.subSave);
    this.subSave = this.gestionGefSvc.modificationMasseGefConnectionFlux(idList, this.selectedFluxList)
      .subscribe({
        next: () => {
          this.isSaving = false;
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Flux mis à jour avec succès sur ${idList.length} configuration(s)`);
          this.gestionGefSvc.announceRefreshGefConnections();
          this.closeDialog();
        },
        error: () => {
          this.isSaving = false;
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.ERROR, `Erreur lors de la modification en masse des flux GEF`);
        }
      });
  }

  closeDialog(): void {
    this.displayDialog = false;
    this.connectionList = [];
    this.selectedFluxList = [];
    this.isSaving = false;
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subOpenDialog);
    this.utilsSvc.unsubscribe(this.subSave);
  }
}
